// extracted by mini-css-extract-plugin
export default {"indicator":"indicator--fLijV","primaryIndicator":"primaryIndicator--NQlrf","secondaryIndicator":"secondaryIndicator--s9oKZ"};